module.exports = __webpack_public_path__ + "img/dropdown-arrow.577ffa0b.svg";